export default __webpack_public_path__ + "56b5e771cc6b3b187556deef5da41b36.png";